import * as Yup from "yup";

export const baseValidationSchema = Yup.object().shape({
  lastname: Yup.string().required("Required"),
  firstname: Yup.string().required("Required"),
});

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const emailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(EMAIL_REGEX, "Invalid email format")
    .required("Required"),
});

export const mobileValidationSchema = Yup.object().shape({
  mobile: Yup.string()
    .min(11, "At least 11 digits")
    .max(11, "Cannot be more than 11 digits")
    .matches(/^(09)\d{9}$/, "Invalid format")
    .required("Required"),
});

export const passwordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .matches(/(?=.*?[A-Z])/, "At least one Uppercase")
    .matches(/(?=.*?[a-z])/, "At least one Lowercase")
    .matches(/(?=.*?[0-9])/, "At least one Digit")
    .matches(/(?=.*?[#?!@$%^&*-])/, "At least one Special Character")
    .matches(/.{8,}/, "At least 8 characters")
    .required("Required"),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Required"),
});
